import Swiper from "swiper"
import {SwiperOptions} from "swiper/types"
import {EffectCreative, Keyboard, Pagination, Navigation} from "swiper/modules"

const pricingSliders = document.querySelectorAll<HTMLElement>(".g-pricing-slider")

pricingSliders.forEach((slider) => {
  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, EffectCreative, Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: -20,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: slider.closest(".s-pricing-slider")?.querySelector<HTMLElement>(".g-pricing-slider__button.--next"),
      prevEl: slider.closest(".s-pricing-slider")?.querySelector<HTMLElement>(".g-pricing-slider__button.--prev"),
    },
    effect: "creative",
    creativeEffect: {
      prev: {
        translate: [0, 0, -400],
        opacity: 0,
      },
      next: {
        translate: ["calc(100% - 20px)", 0, 0],
      },
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: -10,
        creativeEffect: {
          prev: {
            translate: [0, 0, -400],
            opacity: 0,
          },
          next: {
            translate: ["calc(100% - 10px)", 0, 0],
          },
        },
      },
    },
    on: {
      init: () => {
        slider.classList.remove("--loading")
      },
    },
  }

  new Swiper(slider, swiperSettings)
})
